<mat-form-field appearance="fill"
  floatLabel="always"
  subscriptSizing="dynamic"
  class="document-menu-bar"
                [ngClass]="
  'rkt-FormField--full-width'">
  <mat-label>Document</mat-label>
  <mat-select data-private [disableRipple]="true" [hideSingleSelectionIndicator]="true" panelClass="rkt-SelectPanel"
    [(ngModel)]="selectedPackageDocument"
    (selectionChange)="onDocumentSelect($event)">
    @for (packageDocument of packageDocuments$ | async; track packageDocument) {
      <mat-option data-private class="test"
        [value]="packageDocument">
        <div class="document-endorsement-status">
          <app-document-endorsement-status [packageDocument]="packageDocument"></app-document-endorsement-status>
          <div class="document-text">{{ packageDocument.documentName }}</div>
        </div>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
